<template>
  <section
    v-if="show"
    id="recommendation-list"
    class="recommendation-list"
  >
    <transition name="transition-fade">
      <div
        v-if="loading"
        class="cart-overview__loading"
      >
        <loader-spinner :size="1.5" />
      </div>
    </transition>

    <header class="recommendation-list__header">
      <h2 class="recommendation-list__title">
        {{ $t('title') }}
      </h2>
    </header>

    <transition-group
      name="transition-fade"
      tag="div"
    >
      <banner
        key="banner"
        center
        color="primary-dark"
        class="recommendation-list__warning"
      >
        {{ $t('voucherHint') }}
      </banner>

      <div
        v-if="!loading"
        key="data"
        class="recommendation-list__content"
      >
        <recommendation
          v-for="key in sorting"
          :key="key"
          :title="$t('labels.title.' + key)"
          :list="Object.values($t('labels.list.' + key))"
          :tag="$t('labels.tag.' + key) || ''"
          :img-alt="$t('labels.title.' + key)"
          :img-src="imgName(key)"
          :tickets="vouchers[key]"
          :ticket-type="key"
        />
      </div>
    </transition-group>
  </section>
</template>

<script>
import recommendation from './recommendation.vue'
import loaderSpinner from './loaderSpinner.vue'
import banner from './banner.vue'

import { BASE_URL } from '../settings.js'

export default {
  name: 'CRecommendationList',

  components: {
    recommendation,
    loaderSpinner,
    banner
  },

  data () {
    return {
      show: true,
      loading: true,
      vouchers: this.$store.state.vouchers,
      sorting: ['hafenrundfahrt', 'stadtrundfahrt'] //, 'hamburg']
    }
  },

  created () {
    this.$store.dispatch('getVoucherTypes').then(response => {
      if (response.status === 200) {
        this.vouchers = response.data
        this.loading = false

        // EET
        const products = []
        let index = 1

        this.sorting.forEach(vtype => {
          for (const vid in this.vouchers[vtype]) {
            if (!(vid in this.vouchers[vtype])) { continue }
            const vdata = this.vouchers[vtype][vid]
            let name = ''
            let tid = ''

            if (vtype === 'hamburg') {
              name = 'Voucher Hamburg Dungeon'
              tid = 'wv.du-'
            } else if (vtype === 'hafenrundfahrt') {
              name = 'Voucher Hafenrundfahrt'
              tid = 'wv.hr-'
            } else if (vtype === 'stadtrundfahrt') {
              name = 'Voucher Stadtrundfahrt'
              tid = 'wv.sr-'
            }

            const prod = {
              name: name,
              variant: vdata.text,
              category: 'Tickets/Vouchers',
              tid: tid + vdata.id,
              price: vdata.price,
              taxRate: vdata.tax_rate * 100,
              position: index
            }
            index++
            products.push(prod)
          }
        })

        this.$tracking.eetCheckoutUpsellView(products)
      }
    })
  },

  methods: {
    imgName: function (key) {
      return `${BASE_URL}static/img/voucher-${key}.jpg`
    }
  }
}
</script>

<i18n locale="en">
{
  "title": "Our recommendation for your visit to Hamburg",
  "labels": {
    "title": {
      "stadtrundfahrt": "Sightseeing Tour / City Tour",
      "hafenrundfahrt": "Harbour Tour",
      "hamburg": "Hamburg Dungeon"
    },
    "list": {
      "stadtrundfahrt": [
        "Tickets valid with multiple operators",
        "Bus stop directly infront of the Wunderland"
      ],
      "hafenrundfahrt": [
        "Tickets valid with four operators",
        "Landing pier close by to the Wunderland",
        "You save up to 5 € per ticket"
      ],
      "hamburg": [
        "No waiting time",
        "Right next to the Wunderland",
        "You save up to 2,50€ per ticket"
      ]
    },
    "tag": {
      "stadtrundfahrt": "Very popular",
      "hafenrundfahrt": "Up to<br>25% discount",
      "hamburg": "No waiting time<br>+ 10% discount"
      }
    },
    "voucherHint": "Attention: Please pick up your vouchers of our recommendations at the Miniatur Wunderland."
  }
</i18n>

<i18n locale="de">
{
  "title": "Unsere Empfehlungen für Ihren Hamburg-Aufenthalt",
  "labels": {
    "title": {
      "stadtrundfahrt": "Stadtrundfahrt",
      "hafenrundfahrt": "Hafenrundfahrt",
      "hamburg": "Hamburg Dungeon"
    },
    "list": {
      "stadtrundfahrt": [
        "Tickets bei mehreren Anbietern gültig",
        "Haltestelle direkt vor dem Wunderland"
      ],
      "hafenrundfahrt": [
        "Ticket bei vier Anbietern gültig",
        "Anleger in Wunderland-Nähe",
        "Sie sparen bis zu 5 € pro Ticket"
      ],
      "hamburg": [
        "Keine Wartezeit",
        "Direkt neben dem Wunderland",
        "Sie sparen 2,50 € pro Ticket"
      ]
    },
    "tag": {
      "stadtrundfahrt": "Besonders beliebt",
      "hafenrundfahrt": "Bis zu<br>25% Rabatt",
      "hamburg": "Ohne Wartezeit<br>+ 10% Rabatt"
    }
  },
  "voucherHint": "Achtung: Bitte holen Sie die Gutscheine unserer Empfehlungen vorher im Miniatur Wunderland ab."
}
</i18n>

<style lang="scss">
@import "../css/variables";

.recommendation-list__header {
  text-align: center;
}

.recommendation-list__title {
  margin-bottom: $gutter-sm;

  font-weight: 500;
  text-transform: uppercase;

  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-md;
    font-size: 1.25em;
  }
}

.recommendation-list__warning {
  margin-bottom: $gutter-sm;

  @media (min-width: $breakpoint-lg) {
    font-size: 1.1em;
  }
}
</style>
